import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import history from '../../../libs/history';
import createLink from '../../../libs/createLink';

import {fetchUserWarnings, resetUserWarnings} from "../../../creators/user.warnings";
import {fetchUserFriendsRequest} from "../../../creators/user.friendsRequest";
import {fetchUserFriends} from "../../../creators/user.friends";
import {fetchUser, resetUser} from "../../../creators/user";

import ProfileHeader from './components/ProfileHeader';
import ProfileDescription from './components/ProfileDescription';
import LastVisitors from '../../components/LastVisitors';
import Home from './components/Home';
import {Button} from "../../components/Button";
import Warning from "../../components/warnings/Warning";
import {PageLoader} from "../../components/Loader";
import {Can} from "../../../ability-context";
import Modal from "../../components/Modal";
import {config} from '../../../config';
import Helmet from "react-helmet";
import {Link} from "react-router-dom";
import {canonical, isNoFollowProfil} from "../../../libs/helper";
import CtaCannot from "../../components/CtaCannot";
import Breadcrumbs from "../../components/Breadcrumbs";

class ProfileUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleWarning: false
        };

        this.currentUrl = this.props.match;

        this.refHeader = React.createRef();
    }

    componentDidMount() {
        this.props.resetUser();
        this.props.resetUserWarnings();
        this.props.fetchUser(this.props.match.params.userSlug);
        if (this.props.currentUser && this.props.currentUser._id && (this.props.currentUser._id === this.props.user._id)) {
            history.push(createLink('userMe', this.props.currentUser));
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.userSlug !== this.props.match.params.userSlug) {
            this.props.resetUser();
            this.props.resetUserWarnings();
            this.props.fetchUser(this.props.match.params.userSlug);
            window.scrollTo(0, 0);
        }
        if (this.props.user._id && prevProps.user.slug !== this.props.user.slug ) {
            if(config.genderUrl[this.props.user.profile.gender] !== this.props.match.params[0]){
                history.push(createLink('userProfile', this.props.user));
            }
            if(this.props.currentUser && this.props.currentUser._id && (this.props.currentUser._id === this.props.user._id)){
                history.push(createLink('userMe', this.props.currentUser));
            }
            if(this.props.currentUser && this.props.currentUser._id){
                this.props.fetchUserFriends(this.props.user._id);
                this.props.fetchUserWarnings(this.props.user._id);
                let isIgnored = this.props.currentUser.usersIgnored && this.props.currentUser.usersIgnored.includes(this.props.user._id);
                this.setState({isIgnored})
            }
        }
    }

    componentWillUnmount() {
        this.props.resetUser();
        this.props.resetUserWarnings();
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.props.currentUserInitialized !== nextProps.currentUserInitialized){
            return true;
        }
        if(this.props.userInitialized !== nextProps.userInitialized){
            return true;
        }
        if(this.props.userWarningsInitialized !== nextProps.userWarningsInitialized){
            return true;
        }
        if(this.props.userFriendsTotal !== nextProps.userFriendsTotal){
            return true;
        }
        if(this.props.user.isFriendRequestPending !== nextProps.user.isFriendRequestPending){
            return true;
        }
        if (this.props.user.isFollow !== nextProps.user.isFollow) {
            return true;
        }
        if (this.state.toggleWarning !== nextState.toggleWarning) {
            return true;
        }
        return nextProps.match.params.userSlug !== this.props.match.params.userSlug;
    }

    render() {
        // let isFriend = (this.props.user && this.props.user.isFriend) || false;
        let userContent = this.props.user && this.props.user.profile && this.props.user.profile.description ? this.props.user.profile.description : "";
        let breadCrumbsData = [{
            name : this.props.user.username,
            link : canonical(createLink('userProfile', this.props.user), "", "profile"),
            to : createLink('userProfile', this.props.user),
        }];
        // console.log('RENDER PROFILE', this.props.user.username, this.props.userInitialized, this.props.userLoading);

        return !this.props.userInitialized ? <PageLoader/> : (
            <div id="profil">
                <Helmet>
                    <title>Profil Voissa de {this.props.user.username}</title>
                    {isNoFollowProfil(this.props.use) ? <meta name="robots" content="noindex" /> : null}
                    <meta name="description" content={userContent.substring(0, 140)} />
                    <link rel="canonical" href={canonical(createLink('userProfile', this.props.user), "", "profile")} />
                </Helmet>
                <div className="container">
                    <ProfileHeader
                        match={this.currentUrl}
                        isMe={false}
                        user={this.props.user}
                        forwardRef={this.refHeader}
                        onRef={ref => (this.refHeader = ref)}
                        // forwardRef={this.refHeader}
                    />
                    <div className={"card"}><Breadcrumbs data={breadCrumbsData} /></div>
                    <div className="layout-sidebar">
                        <div className="sidebar">
                            {/*{*/}
                            {/*    !!this.props.userWarningsTotal && (*/}
                                    <Can action={"read"} subject={this.props.currentUser} modelName="Warning">
                                        <div className="btn-group column mb-16">
                                            <Button
                                                className="full"
                                                size={"medium"}
                                                btnStyle={this.props.userWarningsTotal >= 1 ? 'cancel-reverse' : 'cancel'}
                                                badgeContent={this.props.userWarningsTotal}
                                                badgeStyle={this.props.userWarningsTotal >= 1 ? 'dark' : 'red-reverse'}
                                                content="Messages de modération"
                                                onClick={() => this.setState({toggleWarning: true})}
                                            />
                                            <Modal toggle={this.state.toggleWarning}
                                                   handleClose={() => this.setState({toggleWarning: false})}>
                                                <Warning username={this.props.user.username}
                                                         userId={this.props.user._id}
                                                         handleClose={() => this.setState({toggleWarning: false})}/>
                                            </Modal>
                                        </div>
                                    </Can>
                            {/*    )*/}
                            {/*}*/}

                            {/*{this.props.currentUserInitialized && (*/}
                            {!this.props.user.setting.chatWithOnlyWithFriends && ( <div className="btn-group column mb-16">
                                        <Can action="create" subject="Room" passThrough>
                                            {can => {
                                                return can ? (
                                                    <Link to={{
                                                        pathname: createLink("messengerCreate"),
                                                        query: {users: [this.props.user]}
                                                    }}
                                                          className="btn full  medium btn-rounded-corner "><span
                                                        className="name">Chatter avec {this.props.user.username}</span></Link>
                                                ) : (
                                                    <CtaCannot action={"rooms"} isModal={true} button={{content : `Chatter avec ${this.props.user.username}`, className: "btn full  medium btn-rounded-corner " }} />
                                                )}}
                                        </Can>
                                </div>)}
                            {/*)}*/}

                            {this.props.currentUserInitialized && (
                                <div className="btn-group column mb-16">
                                    <div className="btn full medium btn-rounded-corner default-cursor"><span
                                        className="name">{config.role[this.props.user.role]} </span></div>
                                </div>
                            )}

                            {(this.props.user._id && this.props.user._id !== null)  && (this.props.isHidden990 && this.props.location.pathname === createLink("userProfile", this.props.user)) ? (
                                <ProfileDescription
                                    isMe={false}
                                    user={this.props.user}
                                    match={this.props.match}
                                    location={this.props.location}
                                    userInitialized={this.props.userInitialized}
                                />
                            ) : (this.props.user._id && this.props.user._id !== null)  && !this.props.isHidden990 && (
                                <ProfileDescription
                                    isMe={false}
                                    user={this.props.user}
                                    match={this.props.match}
                                    location={this.props.location}
                                    userInitialized={this.props.userInitialized}
                                />
                            )}
                            {!this.props.userLoading && (
                                <LastVisitors   userId={this.props.user._id}/>
                            )}
                        </div>
                        {!!this.props.user.username && (
                            <Home {...this.props}
                                  isMe={false}
                                  user={this.props.user}
                                  currentUser={this.props.currentUser}
                            />
                        )}

                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user.data,
        userLoading: state.user.loading,
        userInitialized: state.user.initialized,

        currentUser: state.currentUser.data,
        currentUserInitialized: state.currentUser.initialized,

        userWarnings: state.userWarnings.data,
        userWarningsTotal: state.userWarnings.total,
        userWarningsLoading: state.userWarnings.loading,
        userWarningsInitialized: state.userWarnings.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUser,
    resetUser,
    fetchUserWarnings,
    resetUserWarnings,
    fetchUserFriends,
    fetchUserFriendsRequest
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileUser);
